'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _DataSelector = require('../../common/Class/DataSelector');

var _DataSelector2 = _interopRequireDefault(_DataSelector);

var _Helpers = require('../../common/Helpers');

var _Overlay = require('../Overlay2');

var _Overlay2 = _interopRequireDefault(_Overlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACTIVE_CLASS = 'media-text__video-html5--enabled';
var DEBOUNCE_TIMEOUT = 500;
var selectors = {
  videos: new _DataSelector2.default('data-video-id'),
  videoTriggers: new _DataSelector2.default('data-video-modal-trigger')
};
var dom = {};

/** @private */
var cacheDom = function cacheDom() {
  dom.videos = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(selectors.videos.bracketed()) || []));
  dom.videoTriggers = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(selectors.videoTriggers.bracketed()) || []));
};

/** @private */
var bindListeners = function bindListeners() {
  dom.videoTriggers.forEach(function (el) {
    return el.addEventListener('click', function (e) {
      return e.preventDefault();
    });
  });
  dom.videoTriggers.forEach(function (el) {
    return el.addEventListener('click', openVideoModal);
  });

  _Overlay2.default.on('disable', function () {
    dom.videos.forEach(hideVideo);
  });
};

/**
 * @private
 * @param {Element} el
 */
var hideVideo = function hideVideo(el) {
  el.setAttribute('tabindex', '-1');
  el.pause();
  el.currentTime = 0;
  (0, _Helpers.removeClass)(el, ACTIVE_CLASS);
};

var showVideo = function showVideo(el) {
  el.setAttribute('tabindex', '0');
  el.play();
  (0, _Helpers.addClass)(el, ACTIVE_CLASS);
};

/**
 * @param {Element} el
 * @param {String} attr - attribute name
 */
var findParentWithAttr = function findParentWithAttr(el, attr) {
  if (!el) {
    return;
  } else if (el.getAttribute(attr)) {
    return el;
  }
  return findParentWithAttr(el.parentElement, attr);
};

/**
 * @private
 * @desc find the corresponding video element given an id
 * @param {String} id
 * @return {Element|undefined}
 */
var findVideoElement = function findVideoElement(id) {
  return dom.videos.reduce(function (acc, el) {
    if (el.dataset[selectors.videos.key()] === id) {
      acc = el;
    }
    return acc;
  });
};

/**
 * @private
 * @param {Event} event
 * @return {Function} debounced
 */
var openVideoModal = (0, _Helpers.debounce)(function (event) {
  var targetElement = findParentWithAttr(event.target, selectors.videoTriggers._selector);
  var id = targetElement.dataset[selectors.videoTriggers.key()];
  var videoElement = findVideoElement(id);

  if (videoElement) {
    _Overlay2.default.enable();
    showVideo(videoElement);
  }
}, DEBOUNCE_TIMEOUT);

/**
 * @public
 * @interface VideoModal
 */
exports.default = {
  init: function init() {
    cacheDom();
    bindListeners();
  }
};